let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jpwDp")).then(() => parcelRequire('9H0ZF'));